import { createContext } from 'react';

/**
 * Where the model's memory of this chat starts. Provided once for the whole
 * thread (MessagesContainer) and read by every level of Messages, since a
 * question can sit inside a run.
 */
export const MemoryLineContext = createContext<{
  anchorId?: string;
  above: Set<string>;
}>({ above: new Set() });

/** How faded the questions Signals no longer remembers are: still readable
 *  and selectable, plainly behind the line. */
export const FORGOTTEN_OPACITY = 0.45;

const focusComposer = () => {
  const input = document.getElementById('chat-input');
  if (input) {
    input.focus();
    input.scrollIntoView({ block: 'nearest' });
  }
};

/**
 * The line above the oldest question Signals still remembers. Everything
 * above it is drawn faded; "Ask again" takes the user to the composer, since
 * asking is the way to bring an old question back into memory.
 */
export default function MemoryDivider() {
  return (
    <div role="note" className="flex items-center gap-3 my-2">
      <span
        aria-hidden="true"
        className="flex-1 h-px bg-[var(--sig-border-strong)]"
      />
      <span className="flex items-center gap-2 rounded-full border px-3 py-1 text-[12px] text-[var(--sig-muted)] bg-[var(--sig-panel)] border-[var(--sig-border-strong)] text-center">
        <svg
          aria-hidden="true"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="shrink-0"
        >
          <path d="M12 8v4l3 2" />
          <circle cx="12" cy="12" r="9" />
        </svg>
        <span>
          Signals no longer remembers the questions above ·{' '}
          <button
            type="button"
            className="underline underline-offset-2 hover:text-[var(--sig-ink)]"
            onClick={focusComposer}
          >
            Ask again
          </button>
        </span>
      </span>
      <span
        aria-hidden="true"
        className="flex-1 h-px bg-[var(--sig-border-strong)]"
      />
    </div>
  );
}
